export const CHECK_STOCK_REQUEST = "CHECK_STOCK_REQUEST";
export const CHECK_STOCK_SUCCESS = "CHECK_STOCK_SUCCESS";
export const CHECK_STOCK_FAILURE = "CHECK_STOCK_FAILURE";